<script lang="ts">
    let className = "bg-white dark:bg-neutral-800"
    export { className as class }
</script>
<div class="absolute {className} h-3 left-0 bottom-0 rotate-180 right-0 pointer-events-none z-2">

</div>
<div class="absolute {className} h-3 left-0 top-0 right-0 pointer-events-none z-2">

</div>

<style>
div {
  mask-image: linear-gradient(rgba(0, 0, 0, 0.5), transparent);
}
</style>
